export const avatars = [
  {
    img: "dog.png",
  },
  {
    img: "hacker.png",
  },
  {
    img: "boy.png",
  },
  {
    img: "man.png",
  },
  {
    img: "ninja.png",
  },
  {
    img: "sailor.png",
  },
  {
    img: "teacher.png",
  },
  {
    img: "otaku.png",
  },
  {
    img: "astronaut.png",
  },
  {
    img: "human.png",
  },
  {
    img: "cat.png",
  },
  {
    img: "ghost.png",
  },
  {
    img: "gamer.png",
  },
  {
    img: "panda.png",
  },
  {
    img: "profile.png",
  },
  {
    img: "girl.png",
  },
  {
    img: "avatar.png",
  },
  {
    img: "customer-service.png",
  },
  {
    img: "happy.png",
  },
  {
    img: "gorilla.png",
  },
  {
    img: "man-3.png",
  },
  {
    img: "meerkat.png",
  },
  {
    img: "woman-6.png",
  },
  {
    img: "boy-2.png",
  },
];
